import { type } from 'os'
import { TextBoxTypeEnum } from '../../../enums/TextBoxTypeEnum'
import Typeahead, { ProvideTypeahead } from './Typeahead'
import { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { ReducerType } from '../../../storeManager/ReducerType'
import Select from '../Selects/Select'

type ListChildrenType<TData> = {
  listData?: Array<TData>
  className?: string | undefined
  valueField: string
  onClick?: (param: any) => void
}

function TypeaheadText<TData = Object>({
  listData,
  innerText,
  fieldItem,
  fieldValue,
  Regular,
  RxgMessage,
  className,
  id,
  isLtR,
  isReadOnly,
  isRequired,
  msgValidate,
  name,
  onBlur,
  onChange,
  onFocus,
  onKeyDown,
  classNameList,
  value,
  debounceTime,
  selected,
  hasSearch,
}: TypeaheadTextInterface<TData>) {
  const [showItem, setShowItem] = useState<boolean>(false)
  const [data, setData] = useState<TData | null>(value ?? null)
  const device = useSelector<ReducerType, DeviceModeInterface>(
    (n) => n.reducerDevice
  )
  const [listDataSearch, setListDataSearch] = useState<TData[] | undefined>(
    listData
  )
  const selectedItem = (e: TData) => {
    selected?.(e)
    setData(e)
  }
  const change = (event: any) => {
    const newList = listData?.filter((n) =>
      n[fieldItem].includes(event.target.value)
    )
    setListDataSearch(newList)
    onChange?.(event)
  }
  return (
    <>
      {device.Mobile || device.Tablet ? (
        <Select
          isRequired={isRequired}
          msgValidate={`${innerText} نمیتواند خالی باشد`}
          onChange={(e) => {
            const data = listData?.find(
              (n) => n[fieldValue] == e.target.value
            ) as TData
            selectedItem(data)
          }}
          debounceTime={debounceTime}
          name={name}
          value={data?.[fieldValue] ?? ''}
          className={className}
        >
          <>
            <option value={''}>{innerText}</option>
            {listData?.map((n, i) => (
              <option key={i} value={n[fieldValue]}>
                {n[fieldItem]}
              </option>
            ))}
          </>
        </Select>
      ) : (
        <ProvideTypeahead
          classChildren='!w-full !mx-none !-translate-x-0 !bg-white'
          listChildren={
            <ListItem<TData>
              listData={
                listDataSearch?.length !== 0 ? listDataSearch : listData
              }
              valueField={fieldItem}
              className={`${classNameList}`}
              onClick={(n) => {
                selectedItem(n)
              }}
            />
          }
          showList={showItem}
        >
          <div className=' flex justify-start items-end'>
            <Typeahead
              innerText={innerText}
              onBlur={() => {
                setTimeout(() => {
                  setShowItem(false)
                  onBlur?.()
                }, 100)
              }}
              onFocus={() => {
                setShowItem(true)
                onFocus?.()
              }}
              debounceTime={hasSearch ? 1 : debounceTime}
              className={`!w-full ${className} !border-b`}
              Regular={Regular}
              RxgMessage={RxgMessage}
              Type={TextBoxTypeEnum.Text}
              id={id}
              isLtR={isLtR}
              isReadOnly={hasSearch && listData?.length! > 1 ? false : isReadOnly}
              isRequired={isRequired}
              msgValidate={msgValidate}
              name={name}
              onChange={hasSearch ? change : onChange}
              onKeyDown={onKeyDown}
              value={data?.[fieldItem] ?? ''}
            ></Typeahead>
          </div>
        </ProvideTypeahead>
      )}
    </>
  )
}

function ListItem<TData>({
  className,
  listData,
  valueField,
  onClick,
}: ListChildrenType<TData>) {
  return (
    <>
      <div className={`${className ?? ''} overflow-y-auto`}>
        <ul className={`flex justify-center flex-col items-center shadow-sm `}>
          {listData?.map((n, i) => (
            <li
              key={i}
              className='flex justify-start px-2 items-center border-b-disable border-b py-1.5  w-full '
              onClick={() => {
                onClick?.(n)
              }}
            >
              <p className='text-xs text-primary'>{n[valueField]}</p>
            </li>
          ))}
        </ul>
      </div>
    </>
  )
}
export default TypeaheadText
